import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["as"];
import React, { memo, useMemo } from "react";
import getCellType from "./logic";
import { jsx as _jsx } from "react/jsx-runtime";
function Cell(_ref) {
  var cellType = _ref.cellType,
    restProps = _ref.restProps,
    item = _ref.item,
    emptyPlaceholderText = _ref.emptyPlaceholderText;
  var cellProps = useMemo(function () {
    return getCellType(cellType, restProps, item, emptyPlaceholderText);
  }, [cellType, restProps, item, emptyPlaceholderText]);
  var Component = cellProps.as,
    rest = _objectWithoutProperties(cellProps, _excluded);
  return /*#__PURE__*/_jsx(Component, _extends({}, rest));
}
var MemoizedCell = /*#__PURE__*/memo(Cell);
MemoizedCell.displayName = "MemoizedCell";
export default MemoizedCell;